<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="2"></b-col>
			<b-col lg="8">
				<b-card :no-body="true">
					<b-card-body class="p-0 clearfix">
						<div class="profile-avatar avatar-bg font-2xl mr-3 float-left">
							<div v-if="user.photoURL === null || user.photoURL === ''" class="avatar_hrs_profile avatar-bg">{{ user.display_name | short_name}}</div>
							<img v-else :src="user.photoURL" class="img-avatar" :alt="user.email">
							<div class="actions p-2">
								<b-button variant="primary" size="sm" @click.stop="click_openEditUserPicture($event.target)">Uredi</b-button>
								<b-button v-if="user.photoURL !== null || user.photoURL !== ''" variant="danger" size="sm" @click.stop="click_removeUserPicture($event.target)">Odstrani</b-button>
							</div>
						</div>
						<div class="h1 text-primary mb-0 pt-3">{{ user.display_name }} (#{{ user.dbid }})</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs">{{ user.email }}</div>
						<div class="text-muted text-uppercase mt-3 font-xs">Čas zadnje prijave: <b>{{ user.lastSignInTime }}</b></div>
						<div class="text-muted mt-1 font-xs">ČAS ZADNJEGA DOSTOPA: <b>{{ timestampIzpis(user.last_access_at) }}</b></div>
						<div class="text-muted mt-1 font-xs">IP ZADNJEGA DOSTOPA: <b>{{ user.last_access_ip }}</b></div>
						<div class="profil-geslo mr-4">
							<b-button variant="primary"  @click.stop="click_openEditUserPassword($event.target)">Spremeni geslo</b-button>
						</div>
					</b-card-body>
				</b-card>
			</b-col>
			<b-col lg="2"></b-col>
		</b-row>
		<b-row>
			<b-col lg="2"></b-col>
			<b-col sm="2" md="2">
				<b-card>
					<div class="h1 text-muted text-right mb-4">
						<i class="icon-badge"></i>
					</div>
					<div class="h4 mb-0">10.200 €</div>
					<small class="text-muted text-uppercase font-weight-bold">Znesek prodaje</small>
					<b-progress height={} class="progress-xs mt-3 mb-0" variant="info" :value="25" />
				</b-card>
			</b-col>
			<b-col sm="2" md="2">
				<b-card>
					<div class="h1 text-muted text-right mb-4">
						<i class="icon-basket-loaded"></i>
					</div>
					<div class="h4 mb-0">38</div>
					<small class="text-muted text-uppercase font-weight-bold">Prodanih vozil</small>
					<b-progress height={} class="progress-xs mt-3 mb-0" variant="warning" :value="25" />
				</b-card>
			</b-col>
			<b-col sm="2" md="2">
				<b-card>
					<div class="h1 text-muted text-right mb-4">
						<i class="icon-pie-chart"></i>
					</div>
					<div class="h4 mb-0">28%</div>
					<small class="text-muted text-uppercase font-weight-bold">Delež prodaje</small>
					<b-progress height={} class="progress-xs mt-3 mb-0" :value="28" />
				</b-card>
			</b-col>
			<b-col sm="2" md="2">
				<b-card>
					<div class="h1 text-muted text-right mb-4">
						<i class="icon-speedometer"></i>
					</div>
					<div class="h4 mb-0">5:34</div>
					<small class="text-muted text-uppercase font-weight-bold">Čas rezervacij</small>
					<b-progress height={} class="progress-xs mt-3 mb-0" variant="danger" :value="25" />
				</b-card>
			</b-col>
			<b-col lg="2"></b-col>
			
			<edit-user-password-modal ref="EditUserPasswordModal" @user_edit="edit_password" />
			<edit-user-picture-modal ref="EditUserPictureModal" @edit_picture="edit_picture"/>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>
<script>
import EditUserPasswordModal from '@/components/EditUserPasswordModal';
import EditUserPictureModal from '@/components/EditUserPictureModal';
import firebase from 'firebase';
import { format } from 'date-fns';
import settings from '@/settings.js';

export default {
	name: 'Profile',
	components: {
		'edit-user-password-modal': EditUserPasswordModal,
		'edit-user-picture-modal': EditUserPictureModal
	},
	filters: {
	},
	methods: {
		click_remove: function (data, button) {
			console.log(data);
		},
		click_edit: function (data, button) {
			console.log(data);
		},
		click_showInfo: function (data, button) {
			console.log(data);
		},
		click_openEditUserPassword: function (button) {
			this.$refs.EditUserPasswordModal.showModal(this.user);
		},
		click_openEditUserPicture: function (button) {
			this.$refs.EditUserPictureModal.showModal(this.user);
		},
		click_removeUserPicture: function (button) {
			this.uploadValue = 100;
			let usr = firebase.auth().currentUser;
			// update firebase user photo
			usr.updateProfile({
				photoURL: null
			}).then(() => {
				// update local storage
				let newUser = { ...this.user };
				newUser.photoURL = null;
				this.$store.dispatch('setUser', newUser);
				this.$refs.toastr.s('Slika odstranjena');
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				this.modalErrorMsg = 'Napaka pri odstranjevanju slike uporabnika.';
			});
		},
		edit_password: function () {
			this.$refs.toastr.s('Geslo posodobljeno');
			console.log('Password update successful');
		},
		edit_picture: function () {
			this.$refs.toastr.s('Slika posodobljena');
			console.log('Picture update successful');
		},
		timestampIzpis: function (timestamp) {
			let result = '';
			if (timestamp) {
				let datum = format(timestamp.substring(0, 10), settings.viewDtFormat);
				let ura = timestamp.substring(11, 19);
				result = 'Dne ' + datum + ' ob ' + ura;
			}
			return result;
		}
	},
	data: () => {
		return {
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			items: [],
			filter: null
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		}
	},
	created () {
	}
};
</script>
<style>
	.profile-avatar {
		position: relative;
	}
	.profile-avatar .avatar_hrs_profile {
		height: 200px;
		width: 200px;
		line-height: 199px;
		text-align: center;
		font-size: 4em;
		color: #29363d;
	}
	.profile-avatar .img-avatar {
		border-radius: 0;
		height: 200px;
		width: 200px;
	}
	.profile-avatar .actions {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		text-align: center;
	}
	.profil-geslo {
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// src/views/Profile.vue